import type { FC, ReactNode } from "react";
import { useLocation } from "react-router-dom";
import { isFramedWindow, isPublicCareersPath } from "@/utils/publicCareers";
import { FramedRouteNotice } from "./FramedRouteNotice";

/**
 * Framed (a customer's website embedding the careers page), only the public careers routes render; any other route
 * shows a link that opens it in its own tab instead. The server's framing headers (X-Frame-Options SAMEORIGIN on
 * everything but /join-us) are checked on the first document load only: a link or a history move inside the frame
 * changes the route without asking the server again, so without this the app's sign-in or a department's schedule
 * could open inside someone else's page.
 */
export const FramedRouteGuard: FC<{ children: ReactNode }> = ({ children }) => {
	const { pathname } = useLocation();
	return isFramedWindow() && !isPublicCareersPath(pathname) ? <FramedRouteNotice /> : children;
};
